import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonPriceField from '../../../common/fields/PriceField';
import { OriginalDeviationFieldName } from '../../types';
import { MIN_PRICE } from '../../validation';

interface Props {}

const PriceField: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <CommonPriceField
      label={t('originalDeviationPopup.form.price.label')}
      fieldName={OriginalDeviationFieldName.PRICE}
      productType="originals"
      min={MIN_PRICE}
    />
  );
};
PriceField.displayName = 'PriceField';

export default PriceField;
